<template>
    <section class="section lb-full-height privacy">
        <p v-t="'Privacy.title'" class="title has-text-centered"></p>
        <div class="columns is-centered">
            <div class="column is-5">
                <p
                    v-t="'Privacy.responsible_title'"
                    class="subtitle primary-font"
                ></p>
                <p class="secondary-font" v-html=" $t('Privacy.responsible_description')"/>
                   
                <p
                    v-t="'Privacy.conservation_title'"
                    class="subtitle primary-font"
                ></p>
                <p v-html="$t('Privacy.conservation_description')" class="secondary-font"></p>
                <p
                    v-t="'Privacy.rights_title'"
                    class="subtitle primary-font"
                ></p>
                <p v-html="$t('Privacy.rights_description')" class="secondary-font"></p>
            </div>
            <!--div class="column"></div-->
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style scoped>
.column > .subtitle {
    margin-bottom: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.secondary-font /deep/ strong{
    font-family: var(--secondary-font-bold);
    color: #000000;
    font-weight: normal;
}
.privacy{
    color: #000000;
    overflow-y: auto;
}
.subtitle{
    color: #000000;
    font-weight: normal;
}
.title{
    color: #000000;
    font-weight: normal;
}
.column > .subtitle{
    padding-bottom: 0.5rem;
    padding-top: 1.5rem;
}
</style>
